import { z } from 'zod'
import { PostSignupPhoneStatus } from '@/firebase/auth/auth-jwt-schema'

export const StartPostSignupPhoneResponseSchema = z.object({
  status: z.nativeEnum(PostSignupPhoneStatus),
})

export type StartPostSignupPhoneResponse = z.infer<typeof StartPostSignupPhoneResponseSchema>

export type CompletePostSignupPhoneRequest = {
  phone: string
  text_message_consent: boolean
}

export const CompletePostSignupPhoneResponseSchema = z.object({
  completed: z.literal(true),
})

export type CompletePostSignupPhoneResponse = z.infer<typeof CompletePostSignupPhoneResponseSchema>
